<template>
  <div>
    <v-chart :options="options" v-if="serie && serie.serie && serie.serie.length > 0 "></v-chart>
  </div>
</template>
<script>
  import ECharts from 'vue-echarts'
  import moment from 'moment'

  export default{
    components: {
      'v-chart': ECharts
    },
    props:['serie', 'lineColor'],
    computed:{
      minValue(){
        return 0;
      },
      maxValue(){
        return 100
      },
      xAxisData(){
        let ret = []
        for(let obj in Object.keys(this.serie.serie)){

            if(this.serie.serie[obj].day){
              ret.push(moment(this.serie.serie[obj].day).format("DD-MM-YYYY"))
            }
            if(this.serie.serie[obj].hour){
              ret.push(moment(this.serie.serie[obj].hour).format("HH:mm DD-MM-YYYY"))
            }
          }
        return ret
      },
      serieData(){
        let ret = []
        for(let obj in Object.keys(this.serie.serie)){
          ret.push(this.serie.serie[obj].value)
        }
        return ret
      },
      options(){

        let xAxisData = this.xAxisData
        let minValue = this.minValue
        minValue = (minValue > 90) ? 90 : minValue;

        let graph = {
          title:{
            //text: 'test'
            text: this.serie.unitTypeTimeSerie.name,
            textStyle:{
              fontFamily: 'Roboto',
              color: '#FFF',
              fontSize: 18
            },
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'shadow',

              }
          },
          toolbox: {
            
              // feature: {
              //     saveAsImage: {show: true, title: 'Opslaan            '}
              // }
          },
          // title:{
          //   text: this.serie.from,
          //   textStyle: '#fff'
          // },
          legend: {
              data:['Optimalizatie'],

          },
          xAxis: [
              {
                  type: 'category',
                  data: xAxisData,//['28','29','30','31','32','33','34','35','36','37','38','39'],
                  name: '',
                  axisPointer: {
                      type: 'shadow',
                      
                  },
                  axisLabel:{
                    fontFamily: 'Roboto',
                      color: '#ffffff',
                      fontSize: 11,
                      fontWeight: 600,
                      padding: [12,0,0,0]
                  },
                  // nameTextStyle:{
                  //   fontFamily: 'Roboto',
                  //   color: '#ffffff',
                  //   fontSize: 18
                  // },
                  nameLocation: 'center',

              }
          ],
          yAxis: [
              {
                  type: 'value',
                  // name: this.serie.assetUnitTypeTimeSerie.name,
                  min: minValue,
                  axisLabel: {
                      formatter: '{value}%',
                      fontFamily: 'Roboto',
                      color: '#ffffff',
                      fontSize: 14,
                      fontWeight: 600
                  },
                  
                    
                  
                  // nameLocation: 'start',
              }
          ],
          series: [

              {
                  name:this.serie.unitTypeTimeSerie.name,
                  type:'line',
                  color: this.lineColor,
                  lineStyle: {
                      width: 8,
                  },

                  data: this.serieData
              }
          ]
      };
      return graph;
      }
    }
  }
</script>
<style>
.echarts {
  width: 100% !important;

  padding: 0px 6px;
}
</style>
